import React from "react";
import { cn } from "@/lib/utils";

const BORDO = "#7A1A1A";
const COPPER = "#C57B43";

// 1-5 segment göstergesi (kart için, kompakt)
export const Stars = ({ value = 0, max = 5, className }) => {
  return (
    <div className={cn("inline-flex items-center gap-1", className)} aria-label={`${value}/${max}`}>
      {Array.from({ length: max }).map((_, i) => (
        <span
          key={i}
          className="h-1.5 w-4"
          style={{ backgroundColor: i < value ? BORDO : "rgba(26,25,24,0.12)" }}
        />
      ))}
    </div>
  );
};

// Et kimliği — segmentli ölçü çubuğu
export const ScoreBar = ({ label, value = 0, max = 5, hint, accent = false }) => {
  const color = accent ? COPPER : BORDO;
  return (
    <div className="space-y-2">
      <div className="flex items-end justify-between">
        <span className="font-mono text-xs uppercase tracking-wider text-charcoal/80">{label}</span>
        {hint ? (
          <span className="font-mono text-xs text-[#8C857D]">{hint}</span>
        ) : (
          <span className="font-mono text-xs text-[#8C857D]">{value}/{max}</span>
        )}
      </div>
      <div className="flex items-center gap-1.5">
        {Array.from({ length: max }).map((_, i) => (
          <span
            key={i}
            className="h-2.5 flex-1"
            style={{ backgroundColor: i < value ? color : "rgba(26,25,24,0.08)" }}
          />
        ))}
      </div>
    </div>
  );
};

export const MeatIdentityBars = ({ product, className }) => {
  return (
    <div className={cn("space-y-5", className)} data-testid="meat-identity-bars">
      <ScoreBar label="Lezzet" value={product.flavor} />
      <ScoreBar label="Yumuşaklık" value={product.tenderness} />
      <ScoreBar label="Yağlılık" value={product.fat_level} hint={product.fat} />
      <ScoreBar label="Premium Seviye" value={product.premium} accent />
      <ScoreBar label="Pişirme Kolaylığı" value={product.ease} />
    </div>
  );
};

export default MeatIdentityBars;
